const { GET_STAFF_TYPES, GET_STAFF_TYPES_FAILED, GET_STAFF_BY_STAFFTYPE, GET_STAFF_BY_STAFFTYPE_FAILED, GET_STAFF_BY_STAFFTYPE_SUCCESS, GET_STAFF_TYPES_SUCCESS, CREATE_GATEPASS_APPROVER, CREATE_GATEPASS_APPROVER_SUCCESS, CREATE_GATEPASS_APPROVER_FAILED, GET_ALL_APPROVAL_STAFF, GET_ALL_APPROVAL_STAFF_FAILED, GET_ALL_APPROVAL_STAFF_SUCCESS, GET_ALL_GATEPASS_REQUEST, GET_ALL_GATEPASS_REQUEST_FAILED, GET_ALL_GATEPASS_REQUEST_SUCCESS, UPDATE_GATEPASS_REQUEST, UPDATE_GATEPASS_REQUEST_SUCCESS, UPDATE_GATEPASS_REQUEST_FAILED, UPDATE_ADMIN_GATEPASS_REQUEST, UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS, UPDATE_ADMIN_GATEPASS_REQUEST_FAILED, GET_TEACHER_GATEPASS_REPORT, GET_TEACHER_GATEPASS_REPORT_FAILED, GET_TEACHER_GATEPASS_REPORT_SUCCESS, CREATE_GATEPASS_APPROVAL, CREATE_GATEPASS_APPROVAL_FAILED, CREATE_GATEPASS_APPROVAL_SUCCESS, GET_GATEPASS_REPORT, GET_GATEPASS_REPORT_FAILED, GET_GATEPASS_REPORT_SUCCESS, GET_ALL_STAFF, GET_ALL_STAFF_SUCCESS } = require("./constants");

const initialState = {
    loading: false,
    message: null,
    error: null,
    staffTypeList: [],
    staffListByStaffType: [],
    approvalStaffList: [],
    gatePassRequestList: [],
    teacherGatePassList:[],
    gatePassReport:[],
    allStaffList:[],
    isCreated: false
}


const GatePassReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STAFF_TYPES:
        case GET_STAFF_BY_STAFFTYPE:
        case CREATE_GATEPASS_APPROVER:
        case GET_ALL_APPROVAL_STAFF:
        case GET_ALL_GATEPASS_REQUEST:
        case UPDATE_GATEPASS_REQUEST:
        case UPDATE_ADMIN_GATEPASS_REQUEST:
        case GET_TEACHER_GATEPASS_REPORT:
        case CREATE_GATEPASS_APPROVAL:
        case GET_GATEPASS_REPORT:
        case GET_ALL_STAFF:
            return {
                ...state,
                loading: true,
                message: null,
                error: null,
                isCreated: false
            }

        case GET_STAFF_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                staffTypeList: action.payload
            }
        case GET_STAFF_BY_STAFFTYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                staffListByStaffType: action.payload
            }

        case CREATE_GATEPASS_APPROVER_SUCCESS:
        case UPDATE_GATEPASS_REQUEST_SUCCESS:
        case UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS:
        case CREATE_GATEPASS_APPROVAL_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload,
                isCreated: true
            }

        case GET_ALL_APPROVAL_STAFF_SUCCESS:
            return {
                ...state,
                loading: false,
                approvalStaffList: action.payload
            }

        case GET_ALL_GATEPASS_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                gatePassRequestList: action.payload
            }
        case GET_TEACHER_GATEPASS_REPORT_SUCCESS:
            console.log(action.payload)
            return{
                ...state,
                loading: false,
                teacherGatePassList: action.payload
            }
        case GET_GATEPASS_REPORT_SUCCESS:
            return{
                ...state,
                loading: false,
                gatePassReport: action.payload

            }
        case GET_ALL_STAFF_SUCCESS:
            return{
                ...state,
                loading: false,
                allStaffList: action.payload
            }
        case GET_STAFF_TYPES_FAILED:
        case GET_STAFF_BY_STAFFTYPE_FAILED:
        case CREATE_GATEPASS_APPROVER_FAILED:
        case GET_ALL_APPROVAL_STAFF_FAILED:
        case GET_ALL_GATEPASS_REQUEST_FAILED:
        case UPDATE_GATEPASS_REQUEST_FAILED:
        case UPDATE_ADMIN_GATEPASS_REQUEST_FAILED:
        case GET_TEACHER_GATEPASS_REPORT_FAILED:
        case CREATE_GATEPASS_APPROVAL_FAILED:
        case GET_GATEPASS_REPORT_FAILED:
        case GET_ALL_STAFF:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default:
            return state;
    }
}

export default GatePassReducer;